export const SET_SOHO_CUSTOMER_INFO = 'SET_SHOHO_CUSTOMER_INFO'
export const FAILED_SET_SOHO_CUSTOMER_INFO = 'FAILED_SET_SOHO_CUSTOMER_INFO'
export const SET_SOHO_SERVICES  = 'SET_SOHO_SERVICES'